export default "__VITE_ASSET__05bbe65c__"